import { connect } from "react-redux";
import { ApplicationState } from "store";
import {
    actionCreators,
    getAddedExtraPages,
    getCalendar,
} from "page/calendar/store";
import { MonthDivider } from "./month-divider";
import {
    actionCreators as uiActionCreators,
    getActiveNavigationComponent,
} from "ui/store";

const mapStateToProps = (state: ApplicationState) => ({
    calendar: getCalendar(state),
    activeComponent: getActiveNavigationComponent(state),
    addedExtraPages: getAddedExtraPages(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
};

const ConnectedExtraPages = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MonthDivider);

export { ConnectedExtraPages as MonthDividerControlsAccordion };
